<template>
  <div class="trip-details">
    <Header :trip="trip" @close="$emit('close')" />
    <div class="trip-details__body">
      <Sidebar :trip="trip" />
    </div>
  </div>
</template>

<script>
import Header from './my-trips-details-header';
import Sidebar from './my-trips-details-sidebar';

export default {
  name: 'AmexMyTripsDetails',
  components: {
    Sidebar,
    Header,
  },
  props: {
    trip: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.trip-details {
  background-color: #f7f7f7;

  &__body {
    padding: 30px 0 40px;
    width: 1250px;
    margin: 0 auto;
    display: flex;
    gap: 40px;
  }

  &__content {
    flex: 1;
  }
}
</style>
